import { render, staticRenderFns } from "./guoqiRisk.vue?vue&type=template&id=31011122&scoped=true"
import script from "./guoqiRisk.vue?vue&type=script&lang=js"
export * from "./guoqiRisk.vue?vue&type=script&lang=js"
import style0 from "./guoqiRisk.vue?vue&type=style&index=0&id=31011122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31011122",
  null
  
)

export default component.exports